//
//
export const DragThrow = function (isVertical) {
    this.isVertical = isVertical;
    this.target = null;
    this.x = 0;
    this.y = 0;
    this.origin = {
        x: 0,
        y: 0,
    };
    this.velocity = {
        x: 0,
        y: 0,
    };
    this.offset = {
        x: 0,
        y: 0,
    };
    this.dragTimer = null;
    this.clickCoolOffTimer = null;
    this.hasClicked = false;
    this.clickDelay = (e) => {
        if (!this.hasClicked) {
            this.hasClicked = true;
            this.clickCoolOffTimer = setTimeout(() => {
                this.hasClicked = false;
                this.target.handleClick(e);
            }, 50);
        }
    };
    this.startDrag = (x, y) => {
        this.origin.x = x;
        this.origin.y = y;
        this.x = x;
        this.y = y;
        this.velocity.x = 0;
        this.velocity.y = 0;
        this.target.startDrag();
    };
    this.onDrag = (x, y) => {
        this.velocity.x = x - this.x;
        this.velocity.y = y - this.y;
        this.x = x;
        this.y = y;
        this.offset.x = x - this.origin.x;
        this.offset.y = y - this.origin.y;
        this.target.onDrag(this.velocity.x, this.velocity.y);
        return this.offset;
    };
    this.throw = (e) => {
        if (Math.abs(this.velocity.x) + Math.abs(this.velocity.y) > 3) {
            this.target.onThrow(this.velocity.x, this.velocity.y);
        } else {
            this.clickDelay(e);
        }
    };
};
